/**
 * JKL Collection Slider JavaScript
 * Migrated from: shopify-headless/app/components/global/CollectionSlider.tsx
 * 
 * Initializes Swiper carousel for collection categories.
 * Breakpoints match Hydrogen implementation:
 * - Mobile (100-1023px): 1 slide per view, spaceBetween 16px
 * - Desktop (1024px+): 6 slides per view, spaceBetween 24px
 */

import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

/**
 * Initialize Collection Slider Swiper
 */
function initCollectionSlider() {
  const sections = document.querySelectorAll('.jkl-collection-slider');
  
  sections.forEach((section) => {
    const swiperContainer = section.querySelector('.jkl-collection-slider__swiper');
    const prevButton = section.querySelector('.jkl-collection-slider__nav--prev');
    const nextButton = section.querySelector('.jkl-collection-slider__nav--next');
    
    if (!swiperContainer) return;
    
    const categoriesCount = parseInt(swiperContainer.dataset.categoriesCount, 10) || 0;
    
    // If no items, skip initialization
    if (categoriesCount === 0) return;
    
    // Initialize Swiper with Hydrogen-matching breakpoints
    const swiper = new Swiper(swiperContainer, {
      // Base settings
      slidesPerView: 1,
      spaceBetween: 16,
      
      // Breakpoints matching Hydrogen CollectionSlider component
      breakpoints: {
        // Mobile: 1 slide per view
        100: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        // Small tablets: 2 slides
        480: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        // Tablets: 3 slides
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // Small desktop: 4 slides
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        // Desktop: 6 slides per view (matching Hydrogen)
        1024: {
          slidesPerView: 6,
          spaceBetween: 24,
        },
      },
      
      // Navigation arrows
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      
      // Enable mousewheel (matching Hydrogen)
      mousewheel: {
        forceToAxis: true,
      },
      
      // Smooth transitions
      speed: 400,
      
      // Allow touch/swipe
      grabCursor: true,
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous category',
        nextSlideMessage: 'Next category',
      },
    });
    
    // Store swiper instance on container for potential external access
    swiperContainer.swiperInstance = swiper;
  });
}

/**
 * Initialize on DOM ready
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionSlider);
} else {
  // DOM already loaded
  initCollectionSlider();
}

/**
 * Re-initialize on Shopify section load (Theme Editor)
 */
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.jkl-collection-slider__swiper')) {
    initCollectionSlider();
  }
});

/**
 * Handle section unload - destroy Swiper instances
 */
document.addEventListener('shopify:section:unload', (event) => {
  const container = event.target.querySelector('.jkl-collection-slider__swiper');
  if (container && container.swiperInstance) {
    container.swiperInstance.destroy(true, true);
  }
});
